
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class MeltingItemsDialog extends Serenity.EntityDialog<MeltingItemsRow, any> {
        protected getFormKey() { return MeltingItemsForm.formKey; }
        protected getIdProperty() { return MeltingItemsRow.idProperty; }
        protected getLocalTextPrefix() { return MeltingItemsRow.localTextPrefix; }
        protected getNameProperty() { return MeltingItemsRow.nameProperty; }
        protected getService() { return MeltingItemsService.baseUrl; }
        protected getDeletePermission() { return MeltingItemsRow.deletePermission; }
        protected getInsertPermission() { return MeltingItemsRow.insertPermission; }
        protected getUpdatePermission() { return MeltingItemsRow.updatePermission; }

        protected form = new MeltingItemsForm(this.idPrefix);

    }
}